import { createI18n } from "vue-i18n";
import en from "../../public/translations/en.json";

let locale = localStorage.getItem("locale") ?? "en";

const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: "en", // Aggiunto fallback in caso di errore
  messages: {
    en: en},
});

export { i18n };
